export default "__VITE_ASSET__UWZ8$gsi__"